import debug from 'debug'

import PubSub from 'pubsub-js'

import jQuery from '~/client/assets/js/common/jquery'

const log = debug('behaviour:us-packs')

log('`behaviour:us-packs` is awake')

/**
 * Click-simulate the radio input for a label whose data-fe-rule
 * matches `feRule` inside `panelId`. No-op if the label isn't found
 * or the radio is already checked.
 *
 * data-fe-rule is set in ui-element-container/create alongside
 * className. Targeting by FE rule avoids the className collisions
 * between UK and LHD models that share Names (e.g. +170 and +175
 * both render NAME "SEVEN 170" and so share class `seven-170`).
 */
function clickLabelRadio (panelId, feRule) {
  if (!feRule) return false

  const escaped = (window.CSS && window.CSS.escape) ? window.CSS.escape(feRule) : feRule
  // Matrix renders one label per model+pack row, all sharing the same data-fe-rule
  // (e.g. 6 +RPC labels for the 6 R Pack rows). Only the row matching the current
  // model has its input enabled — :not(:disabled) selects it.
  const input = document.querySelector(`${panelId} label[data-fe-rule="${escaped}"] input:not(:disabled)`)
  if (!input) {
    log(`No enabled input for ${panelId} label[data-fe-rule="${feRule}"]`)
    return false
  }

  if (!input.checked) input.click()
  return true
}

/**
 * Handle a US pack tile click. Reads the target model and (optional)
 * pack FE rules from data-attributes, then click-simulates the
 * underlying radios. The pack radio is deferred so rule dependencies
 * resolve from the model click first.
 */
function handleUsPackTileClick () {
  const $ = jQuery()
  const tile = $(this)

  const modelFe = tile.data('model-fe')
  const packFe = tile.data('pack-fe')

  log(`us-pack click: model=${modelFe}, pack=${packFe || 'none'}`)

  const modelClicked = clickLabelRadio('#models_panel', modelFe)

  if (packFe) {
    setTimeout(() => clickLabelRadio('#pack_panel', packFe), 80)
  }

  if (modelClicked) {
    $('.us-pack-tile.active').removeClass('active')
    tile.addClass('active')
  }
}

/**
 * Sync .us-pack-tile.active with the server-rendered Configuration on
 * initial load. Reads from the render-data JSON inlined in home.ejs
 * (independent of renderapp init timing). Without this, a fresh page
 * load with +360+SPC in the URL leaves all 4 tiles unhighlighted until
 * the user clicks one.
 */
function syncActiveTileFromConfiguration () {
  const node = document.getElementById('render-data')
  if (!node) return

  let configuration = ''
  try {
    configuration = (JSON.parse(node.textContent || '{}').Configuration) || ''
  } catch (e) {
    return
  }
  if (!configuration) return

  const tiles = Array.from(document.querySelectorAll('.us-pack-tile'))
  const tile = tiles.find((t) => {
    const m = t.dataset.modelFe
    const p = t.dataset.packFe
    if (m && !configuration.includes(m)) return false
    if (p) return configuration.includes(p)
    // SS / CUP tiles have no packFe — model alone is enough
    return true
  })

  if (tile) {
    tiles.forEach((t) => t.classList.remove('active'))
    tile.classList.add('active')
  }
}

/**
 * Boot handler. The us-packs panel is server-rendered only for the us_test
 * locale (gated in views/home.ejs), so binding here is a no-op on other
 * locales. We can't gate by getRegionCode() at this point — renderData
 * isn't populated until settings load (renderapp.js setRegionCode call),
 * which happens after DOMContentLoaded.
 */
export default function handleContentLoaded () {
  log('handleContentLoaded')

  const $ = jQuery()
  $('#us_packs_panel').on('click', '.us-pack-tile', handleUsPackTileClick)

  // Ensure renderMenuSteps runs after DOM is ready so step numbers
  // reflect the hidden models/packs menu items.
  PubSub.publish('menu:show', 'us-packs')

  syncActiveTileFromConfiguration()
}
